import { CareActivityPageContent } from "../../home/pages/CareActivityPage";

const SharedCareActivityPage = () => <CareActivityPageContent sharedMode />;

export default SharedCareActivityPage;
